import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Stand, StandProduct } from "../../../../data/interfaces";
import Tooltip from "../../../../components/shared/tooltip/Tooltip";
import { ANALYTICS_EVENTS, trackAnalyticsEvent } from "../../../../utils/analytics";

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  stand: Stand;
}

const StandDetailProductsTabView = ({ stand, ...restProps }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------
  // Access to i18n instance that you may use to translate your content.
  const { t } = useTranslation();

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------

  const downloadProduct = (product: StandProduct) => {
    if (!!product.download_url) {
      // Track event
      trackAnalyticsEvent(ANALYTICS_EVENTS.DOWNLOAD_PRODUCT, { stand: stand.name });

      window.open(product.download_url, "_blank");
    }
  };

  /**
   * This method is called the first time the component is mounted
   * @function
   */
  const init = (): void => {
    // init component
    console.log("[StandDetailProductsTabView] init");
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------
  /**
   * This method is called when the component is unmounted
   * @function
   */
  const destroy = (): void => {
    // destroy component
    console.log("[StandDetailProductsTabView] destroy");
  };

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------
  /**
   * This hook is called once when the component is mounted
   */
  useEffect(() => {
    init();
    return () => {
      destroy();
    };
  }, []);

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------

  return (
    <div className={"panel-content products-gallery"}>
      {stand && stand.products && stand.products.length > 0 ? (
        <ul>
          {stand.products.map((product) => (
            <li
              className={"product"}
              key={product.name + product.download_url} /* fake unique key */
            >
              <a
                href={product.image_url}
                data-fancybox="products-gallery"
                data-caption={`<h5>${product.name}</h3><span>${product.description}</span>`}
              >
                <div className={"image"} style={{ backgroundImage: `url(${product.image_url})` }} />
                <span className={"title"}>{product.name}</span>
                <span className={"description"}>{product.description}</span>
              </a>
              <a
                href={`mailto:${stand.email}?subject=Information about ${product.name}`}
                className="btn btn-primary btn-user btn-block"
              >
                {t("pages.standDetail.tabs.products.requestInfo")}
              </a>
              {product.download_url && (
                <>
                  <span
                    onClick={() => downloadProduct(product)}
                    title={t("pages.standDetail.tabs.products.download")}
                    className="download cursor-pointer"
                    data-tip={t("tooltips.products.download")}
                  >
                    <i className="fas fa-download" />
                  </span>
                  <Tooltip />
                </>
              )}
            </li>
          ))}
        </ul>
      ) : (
        <span>{t("pages.standDetail.tabs.noData")}</span>
      )}
    </div>
  );
};
export default StandDetailProductsTabView;
